import { BaseComponentProps } from '@/pages/benchmark/types/commom';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { IMetricFilterOption } from '../BenchmarkFilter/useData';
import { getDownValueType, getMetricFormatRule, nameWidth } from '@/pages/benchmark/utils/utils';
import Abnormal from '@home/components/Abnormal';
import './index.scss';

export interface IGenreTableServiceProps extends BaseComponentProps {
  selectMetricList: IMetricFilterOption[];
  [key: string]: any;
}

const GenreTableService = (props: IGenreTableServiceProps) => {
  const { style, className, children, selectMetricList, ...resetProps } = props;
  const metricMap = props.data?.metricConfig || {};

  const metricColumnList = useMemo(
    () =>
      selectMetricList?.map((item) => {
        const { metric, metric_ch = '', metric_en = '' } = item;
        const { tooltipEn, tooltipCn, formatter, scalar_type } =
          metricMap[metric] || {};
        return {
          metricKey: metric,
          reqMetricKey: metric,
          enWidth: nameWidth(metric_en, true),
          cnWidth: nameWidth(metric_ch, false),
          enName: metric_en,
          cnName: metric_ch,
          tooltipEn,
          tooltipCn,
          type: getDownValueType(formatter, scalar_type),
          formatter: getMetricFormatRule({ formatter, scalar_type })
        };
      }),
    [selectMetricList],
  );

  return (
    <Abnormal
      isLoading={!(metricColumnList?.length > 0) && !resetProps.filterError}
      style={{ height: 616, background: '#fff', marginTop: 20, borderRadius: 8 }}
      component={
        <div
          style={style}
          className={classNames(className, 'genre-table-service-contaniner')}
          key={`${resetProps.activeRadio?.value}-${metricColumnList?.map(item => item?.metricKey)?.toString()}`}
        >
          {React.Children.map(children, (child: any) =>
            React.cloneElement(child, {
              ...resetProps,
              metricColumnList,
            }),
          )}
        </div>
      }
    />
  );
};
export default GenreTableService;
